export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";